import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarsRepository } from '../../core/domain/cars/repositories/cars.repository';
import { GetCarsUseCase } from '@/core/domain/cars/usecases/getCars.usecase';
import { GetMoreCarsUseCase } from '@/core/domain/cars/usecases/getMoreCars.usecase';
import { CarsImplRepository } from './cars-impl.repository';

const GetCarsUseCaseFactory = (carsRepository: CarsRepository) =>
    new GetCarsUseCase(carsRepository);

const GetMoreCarsUseCaseFactory = (carsRepository: CarsRepository) =>
    new GetMoreCarsUseCase(carsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetCarsUseCase,
            useFactory: GetCarsUseCaseFactory,
            deps: [CarsRepository],
        },
        {
            provide: GetMoreCarsUseCase,
            useFactory: GetMoreCarsUseCaseFactory,
            deps: [CarsRepository],
        },
        {
            provide: CarsRepository,
            useClass: CarsImplRepository,
        },
    ],
})
export class CarsDataModule {}
